<template>
  <base-add></base-add>
</template>

<script>
  import baseAdd from './add';
  export default {
    name: 'salesLadingbillEdit',
    components: {
      baseAdd,
    },
  };
</script>
